import * as React from "react"

import { cn } from "@/lib/utils"

// Ticket 151: every raw <table> scrolls inside its own box instead of being
// clipped by an overflow-hidden card or stretching the page. min-w-0 lets it
// shrink when it is a flex/grid child; max-w-full keeps it inside the parent.
// Headers never wrap (a header that wraps into 30-48px columns is unreadable);
// the box scrolls instead. Override with a className such as
// "md:[&_th]:whitespace-normal" to let headers wrap again on wide screens.
const TableScroller = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("w-full min-w-0 max-w-full overflow-x-auto [&_th]:whitespace-nowrap", className)}
    {...props} />
))
TableScroller.displayName = "TableScroller"

export { TableScroller }
